import {Form} from "@/utils/Form";
import {
    UpdateProvisionedDeviceImplementorMutation,
    UpdateProvisionedDeviceImplementorMutationVariables,
    useUpdateProvisionedDeviceImplementorMutation,
} from "./queries.generated";

type FormValues = {
    phoneNumber: string;
    newMacAddress: string;
    vendorId: number;
    currentMacAddress: string;
};

const initialValues = {
    phoneNumber: "",
    newMacAddress: "",
    currentMacAddress: "",
    vendorId: 0,
};

export default class MACAddressForm extends Form<
    UpdateProvisionedDeviceImplementorMutation,
    UpdateProvisionedDeviceImplementorMutationVariables,
    FormValues
> {
    constructor() {
        super("updateProvisionedDeviceImplementor");
        this.hooks(useUpdateProvisionedDeviceImplementorMutation, initialValues);
    }

    protected override get filteredVariables(): UpdateProvisionedDeviceImplementorMutationVariables {
        const params = {...this.values};
        if (params.currentMacAddress === "") delete (params as {currentMacAddress?: string}).currentMacAddress;
        return params;
    }
}
